// extracted by mini-css-extract-plugin
export var container = "_ii-0";
export var infoIcon = "_ii-2";
export var internalLabel = "_ii-3";
export var titleRowCol = "_ii-1";